import React from 'react';
import PropTypes from 'prop-types';
import './BusinessModelPanel.scss';
import {
  Button,
  Heading,
  Paragraph,
} from 'components/common/';
import BusinessModelSection from './BusinessModelSection';

const BusinessModelPanel = ({
  heading,
  subheading,
  compareCta,
  column,
  imageDimensions,
}) => {
  const traditionalColIndex = 0;
  const imageColIndex = 1;
  const ourColIndex = 2;
  return (
    <div className="business-model">
      <div className="container-wrapper">
        <div className="left" />
        <div className="right" />
        <Heading as="h2">{heading}</Heading>
        <Paragraph>{subheading}</Paragraph>
        <div className="content">
          <div className="model-traditional">
            <BusinessModelSection
              column={column[traditionalColIndex]}
              imageDimensions={imageDimensions}
            />
          </div>
          <div className="model-ours">
            <BusinessModelSection
              column={column[ourColIndex]}
              imageColumn={column[imageColIndex]}
              imageDimensions={imageDimensions}
            />
          </div>
          <Button className="compareNowButton" large onClick={() => window.scrollTo(0, 0)}>{compareCta.title}</Button>
        </div>
      </div>
    </div>
  );
};

BusinessModelPanel.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  compareCta: PropTypes.shape({
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  column: PropTypes.arrayOf(PropTypes.shape({
    row: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string.isRequired,
        subheading: PropTypes.string,
        image: PropTypes.shape({
          title: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
        }),
      })
    ),
  })).isRequired,
  imageDimensions: PropTypes.shape({}).isRequired,
};

BusinessModelPanel.defaultProps = {
};

export default BusinessModelPanel;
